import GeografiaMasterPage from './GeografiaMasterPage.jsx';
import { createPais, deactivatePais, listPaises, updatePais } from '@/services/geografia.js';

export default function PaisesPage() {
  return <GeografiaMasterPage title="Países" singular="País" description="Maestro de países con código ISO o interno." list={listPaises} create={createPais} update={updatePais} deactivate={deactivatePais} />;
}
